import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import PreviousWinnersCard from "./PreviousWinnersCard";

const PreviousWinner = () => {

  return (
    <HeaderComponent
      title="Previous Winners"
      description="Recent value champions from past months"
      descriptionClass="text-sm muted-text"
    >
      <div >
        <PreviousWinnersCard/>
      </div>
   </HeaderComponent>
  );
};

export default PreviousWinner;
